import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="app-header">
      <div className="header-container">
        <Link to="/" className="logo">
          <img src="/logo.png" alt="Code by Skillora" className="logo-image" />
        </Link>
        
        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`main-nav ${isMenuOpen ? 'open' : ''}`}>
          <ul>
            <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
            <li><Link to="/app" onClick={() => setIsMenuOpen(false)}>Compiler</Link></li>
            <li><Link to="/java-online-compiler" onClick={() => setIsMenuOpen(false)}>Online Compiler</Link></li>
            <li><Link to="/run-java-code-online" onClick={() => setIsMenuOpen(false)}>Run Java Online</Link></li>
            <li><Link to="/java-playground" onClick={() => setIsMenuOpen(false)}>Java Playground</Link></li>
            <li><Link to="/skillora" onClick={() => setIsMenuOpen(false)}>Code by Skillora</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
